import type { PaidRestRow } from '@/features/Vacations/models/vacationPaidRest.types';

export function buildPaidRestDemoRow(today: Date): PaidRestRow {
    const year = today.getFullYear();
    const periods = [
        { id: 'demo-rest-1', startDate: `${year}-01-12`, endDate: `${year}-01-16`, days: 5, observations: 'Descanso de verão' },
        { id: 'demo-rest-2', startDate: `${year}-07-06`, endDate: `${year}-07-10`, days: 5 },
        { id: 'demo-rest-3', startDate: `${year - 1}-12-15`, endDate: `${year - 1}-12-19`, days: 5 },
    ];

    return {
        collaboratorId: 'demo-paidrest',
        collaboratorName: 'Bruno Exemplo',
        cnpj: '00.000.000/0001-00',
        companyName: 'Empresa Exemplo Ltda',
        hasPaidRest: true,
        paidRestObservations: null,
        paidRestPeriods: periods,
        lastPeriod: periods[1],
        totalDaysYear: 10,
    };
}
